import { saveAs } from "file-saver";
import { nextTick } from "vue";
import { storeToRefs } from "pinia";
import { ExportDocumentFormat } from "~/types/enums/ExportDocumentFormat.enum";
import { useExportCompanionDocumentFromOps } from "./useExportCompanionDocumentFromOps";

export const useDownloadStudentDraft = async (
  documentId: string,
  format: ExportDocumentFormat.pdf | ExportDocumentFormat.docx,
  includeChecklist: boolean = true
) => {
  // Let the editor's watcher copy the latest keystroke into the local revision.
  await nextTick();
  const { revision, submittedDocument } = storeToRefs(
    useSubmittedDocumentStore(documentId)
  );
  if (!submittedDocument.value || !revision.value) {
    throw new Error("The document is still loading.");
  }
  if (!Array.isArray(revision.value.studentSubmissionOps)) {
    throw new Error("The document content is not available yet.");
  }

  const fileName = (submittedDocument.value.name || "Student draft").replace(/\.(docx|pdf)$/i, "");
  const blob = await useExportCompanionDocumentFromOps(
    documentId,
    format,
    true,
    false,
    true,
    fileName,
    true,
    false,
    { includeChecklist, studentDraft: true }
  );

  if (!blob) throw new Error("The download could not be created.");
  saveAs(blob, `${fileName}.${format === ExportDocumentFormat.docx ? "docx" : "pdf"}`);
};
